import { call, put } from 'redux-saga/effects';
import Http from '../../../../libs/Http';

export function* fetchMultiFactor(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.get, '/users/account', {
    query: {}
  });
  yield put({
    type: 'SET_MY_ACCOUNT',
    payload: data,
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* generateMultiFactor(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const response = yield call(Http.post, '/users/generateMultiFactor', {
    body: {
      password: payload.data.password,
    }
  });
  yield put({
    type: 'SET_GENERATED_MULTI_FACTOR',
    payload: response,
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* submitMultiFactorCode(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const response = yield call(Http.post, '/users/multiFactorConfirm', {
    body: {
      code: payload.data.code,
    }
  });
  yield put({
    type: 'FETCH_MY_ACCOUNT',
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export default function*({ takeFirst, takeLatest }) {
  yield [
    takeLatest('FETCH_MY_ACCOUNT', fetchMultiFactor),
    takeFirst('GENERATE_MULTI_FACTOR', generateMultiFactor),
    takeFirst('SUBMIT_MULTI_FACTOR_CODE', submitMultiFactorCode),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/MyAccount/MultiFactor/MultiFactor.sagas.js